// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-radio.active[data-v-1d31bf1e]{background-color:#000;color:#fff}.profile-radio[data-v-1d31bf1e]:not(.active):hover{background-color:rgba(0,0,0,.5)}", ""]);
// Exports
module.exports = exports;
